import React from 'react';
import { Segment } from 'semantic-ui-react';
import { Loader } from '../../Elements';
import appStyles from '../../App/App.scss';
import InvoiceListHeader from './InvoiceListHeader';

export default () => (
  <Segment className={appStyles.segmentContainer}>
    <InvoiceListHeader />
    <Loader />
  </Segment>
);



// WEBPACK FOOTER //
// ./webpack/components/Financial/Invoices/InvoiceListLoader.js